<template>
  <div class="privilege">
    <div class="gold">
      <h2>黄金VIP特权</h2>
      <ul class="privilege-list">
        <li>
          <img src="@/assets/vip/prerogative_1@2x.png" alt="" />
          <p>蓝光高清</p>
        </li>
        <li>
          <img src="@/assets/vip/prerogative_2@2x.png" alt="" />
          <p>全球资源</p>
        </li>
        <li>
          <img src="@/assets/vip/prerogative_3@2x.png" alt="" />
          <p>尊贵图标</p>
        </li>
        <li>
          <img src="@/assets/vip/prerogative_4@2x.png" alt="" />
          <p>新片抢先</p>
        </li>
      </ul>
    </div>
    <div class="masonry">
      <h2>黄金VIP特权</h2>
      <ul class="privilege-list">
        <li>
          <img src="@/assets/vip/prerogative_1@2x.png" alt="" />
          <p>蓝光高清</p>
        </li>
        <li>
          <img src="@/assets/vip/prerogative_2@2x.png" alt="" />
          <p>全球资源</p>
        </li>
        <li>
          <img src="@/assets/vip/prerogative_3@2x.png" alt="" />
          <p>尊贵图标</p>
        </li>
        <li>
          <img src="@/assets/vip/prerogative_4@2x.png" alt="" />
          <p>新片抢先</p>
        </li>
        <li>
          <img src="@/assets/vip/prerogative_5@2x.png" alt="" />
          <p>撩妹权限</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Privilege"
};
</script>
<style lang="scss" scoped>
.privilege {
  text-align: left;
  h2 {
    margin: 30px 20px;
    font-size: 18px;
    font-weight: 500;
    color: rgba(50, 51, 51, 1);
    line-height: 25px;
  }
  .privilege-list {
    padding: 0 15px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    grid-gap: 20px;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 42px;
        height: 42px;
      }
      p {
        margin-top: 5px;
        height: 17px;
        font-size: 12px;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
        line-height: 17px;
      }
    }
  }
}
</style>
